import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AvatarModule } from 'src/app/components/avatar/avatar.module';
import { SharedDirectivesModule } from 'src/directives/shared-directives.module';
import { ColonToEmojiPipe } from 'src/pipes/colonToEmoji.pipe';
import { CustomDatePipe } from 'src/pipes/custom-date.pipe';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { ConversationListComponent } from '../components/conversation-list/conversation-list.component';
import { FilterButtonComponent } from '../components/filter-button/filter-button.component';
import { InboxLayoutManagerModule } from '../components/inbox-layout-manager/inbox-layout-manager.module';
import { ConversationDetailsComponent } from '../conversation-details/conversation-details.component';

import { InboxRoutingModule } from './inbox-routing.module';
import { InboxComponent } from './inbox.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxTippyModule,
    NgxDatatableModule,
    SharedPipesModule,
    SharedDirectivesModule,
    InboxRoutingModule,
    AvatarModule,
    InboxLayoutManagerModule,
    FilterButtonComponent,
    ConversationListComponent,
    ConversationDetailsComponent,
    ColonToEmojiPipe,
    CustomDatePipe,
  ],
  declarations: [InboxComponent],
})
export class InboxModule {}
